import React from "react";
import { Box, Typography, Tooltip } from "@mui/material";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { format, parseISO, differenceInMinutes, isBefore } from "date-fns";

const LineaDeTiempoBus = ({ paradas = [] }) => {
  const now = new Date();

  const paradasConFecha = paradas
    .filter(p => p.parhorest)
    .map(p => ({
      ...p,
      hora: parseISO(p.parhorest)
    }));

  if (paradasConFecha.length < 2) return null;

  const inicio = paradasConFecha[0].hora;
  const fin = paradasConFecha[paradasConFecha.length - 1].hora;
  const duracionTotal = differenceInMinutes(fin, inicio);

  const getPosicion = (hora) => {
    const minDesdeInicio = differenceInMinutes(hora, inicio);
    return Math.min(Math.max((minDesdeInicio / duracionTotal) * 100, 0), 100);
  };

  let posicionBus = 0;
  for (let i = 0; i < paradasConFecha.length - 1; i++) {
    const actual = paradasConFecha[i];
    const siguiente = paradasConFecha[i + 1];

    if (now >= actual.hora && now < siguiente.hora) {
      const duracionTramo = differenceInMinutes(siguiente.hora, actual.hora);
      const transcurrido = differenceInMinutes(now, actual.hora);
      const porcentajeEnTramo = transcurrido / duracionTramo;

      const posActual = getPosicion(actual.hora);
      const posSiguiente = getPosicion(siguiente.hora);
      posicionBus = posActual + (posSiguiente - posActual) * porcentajeEnTramo;
      break;
    }
  }

  if (now >= fin) {
    posicionBus = 100;
  }

  return (
    <Box
      sx={{
        position: 'relative',
        height: 100,
        width: '99%',
        backgroundColor: '#f5f5f5',
        borderRadius: 2,
        px: 2,
        mt: 2,
        boxShadow: 2
      }}
    >
      {/* Línea base */}
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: 0,
          right: 0,
          height: 4,
          backgroundColor: '#1976d2',
          opacity: 0.5,
          transform: 'translateY(-50%)'
        }}
      />

      {/* Paradas */}
      {paradasConFecha.map((parada, idx) => {
        const left = getPosicion(parada.hora);

        // Determinar si ya fue pasada
        const yaPasada = isBefore(parada.hora, now) && idx !== paradasConFecha.length - 1;

        return (
          <Box
            key={parada.manparid}
            sx={{
              position: 'absolute',
              left: `${left}%`,
              top: '50%',
              transform: 'translate(-50%, -50%)',
              textAlign: 'center'
            }}
          >
            <Tooltip title={`${parada.locnom} - ${format(parada.hora, 'HH:mm')}`} arrow>
              <Box display="flex" flexDirection="column" alignItems="center">
                <FiberManualRecordIcon
                  sx={{
                    color: yaPasada
                      ? 'green'
                      : parada.partip === 'ORIGEN'
                      ? 'green'
                      : parada.partip === 'DESTINO'
                      ? 'gray'
                      : 'gray',
                  }}
                />
                {/*
                <Typography
                  variant="caption"
                  fontWeight="bold"
                  color="text.primary"
                  sx={{ maxWidth: 100 }}
                  noWrap
                >
                  {parada.locnom}
                </Typography>
                */}
                <Typography variant="caption" color="text.secondary">
                  {format(parada.hora, 'HH:mm')}
                </Typography>
              </Box>
            </Tooltip>
          </Box>
        );
      })}

      {/* Bus */}
      <Box
        sx={{
          position: 'absolute',
          top: '30%',
          left: `${posicionBus}%`,
          transform: 'translate(-50%, -50%)'
        }}
      >
        <DirectionsBusIcon sx={{ fontSize: 36, color: '#1976d2' }} />
      </Box>
    </Box>
  );
};

export default LineaDeTiempoBus;
